<template>
  <div class="page-with-top-bar">
    <section>
      <div class="mt-4">
        <b-tabs type="is-toggle" v-model="currentActiveTab" expanded size="is-medium">
          <b-tab-item :disabled="sendProcessData">
            <template slot="header">
              <b-icon pack="fas" icon="tasks"></b-icon>
              <span> {{ $t('step') + ' 1' }} </span>
            </template>

            <list-activities ref="list_activities"
              :projectId="projectId"
              :clearSelectItems="activities.length == 0"
              @selected-items="onSelectedItems"
              @selected-subitems="(items) => { subactivities = items }"
              @selected-assignments="onSelectedAssignments"

            />
          </b-tab-item>

          <!-- Acción a realizar sobre la lista previamente seleccionada -->
          <b-tab-item :disabled="(currentActiveTab != 1 && !selectedAction) || sendProcessData">
            <template slot="header">
              <b-icon pack="fas" icon="bolt"></b-icon>
              <span>{{ $t('step') + ' 2' }}</span>
            </template>
            <div>

              <list-users ref="list_users"
                :projectId="projectId"
                :action="selectedAction"
                :collaborator="selectedAction && selectedAction.name === 'assign_collaborators'"
                @selected-linked-entities="(items) => { linkedEntities = items }"
                v-if="showListUsers()"
              />

              <form-data :projectId="projectId"
                :action="selectedAction"
                @selected-linked-entities="(items) => { linkedEntities = items }"
                :optionTags="project.tags"
                v-if="selectedAction && (selectedAction.name === 'change_data' || selectedAction.name === 'link_tags' || selectedAction.name === 'assign_group' )"
              />

              <documents-list :projectId="projectId"
                :action="selectedAction"
                @selected-linked-entities="(items) => { linkedEntities = items }"
                v-if="selectedAction && selectedAction.name === 'link_documents'"
              />

              <validations-list :projectId="projectId"
                :action="selectedAction"
                @selected-linked-entities="(items) => { linkedEntities = items }"
                v-if="selectedAction && selectedAction.name === 'link_validations'"
              />

              <bulk-assign-group v-if="selectedAction && selectedAction.name === 'assign_group_'"
                :projectId="projectId"
                :entity-type="'project'"
                :action="selectedAction"
                @selected-linked-entities="(items) => { linkedEntities = items }"
              />

              <move-assignments-target v-if="selectedAction && selectedAction.name === 'move_assignments'"
                :projectId="projectId"
                :action="selectedAction"
                @selected-linked-entities="(items) => { linkedEntities = items }"
              />

            </div>
          </b-tab-item>

          <!-- Muestra resumen de la acción y opcion para procesar la acción o cancelar -->
          <b-tab-item :disabled="currentActiveTab != 2 && (!linkedEntities.length || (selectedAction && selectedAction.name === 'remove_activities'))">
            <template slot="header">
              <b-icon pack="fas" icon="hourglass-end"></b-icon>
              <span>{{ $t('step') + ' 3' }}</span>
            </template>

            <WizardBulkComplete :activities="activities"
              :subactivities="subactivities"
              :action="selectedAction"
              :linkedEntities="linkedEntities"
              :assignments="assignments"
              :projectId="projectId"
              v-if="selectedAction && (
                ((activities.length || subactivities.length) && (linkedEntities.length || selectedAction.name === 'remove_activities')) ||
                (selectedAction.name === 'remove_assignments' && assignments.length > 0) ||
                (selectedAction.name === 'move_assignments' && assignments.length > 0 && linkedEntities.length > 0)
              )"
              ref="wizard_complete"
            />
          </b-tab-item>

        </b-tabs>

        <div class="sticky bottom-0 ml-4 mr-4">
          <div class="panel mt-0 mb-0">
            <BulkActionsButtons
              :title="$t(
                assignments.length > 0 && activities.length === 0 && subactivities.length === 0
                  ? 'assignment'
                  : 'activity'
              )"
              :show="(activities.length > 0 || subactivities.length > 0 || assignments.length > 0) && currentActiveTab == 0"
              :clearSelect="!selectedAction"
              :setActions="bulkActionsToShow"
              @select-action="onSelectAction"
            />
            <WizardBulkButtons :step="currentActiveTab"
              :complete="currentActiveTab === 2"
              :processingData="sendProcessData"
              @wizard-previus="prevTab"
              @wizard-next="nexTab"
            />
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
  import axios from "axios";
  import ListActivities from "../../components/bulk-actions/activities-list.vue";
  import ListUsers from "../../components/bulk-actions/users-list.vue";
  import FormData from "../../components/bulk-actions/bulk-change-data.vue";
  import DocumentsList from "../../components/bulk-actions/documents-list.vue";
  import ValidationsList from "../../components/bulk-actions/validations-list.vue";
  import WizardBulkButtons from '·/components/bulk-actions/wizard-bulk-buttons';
  import WizardBulkComplete from '·/components/bulk-actions/wizard-bulk-complete';
  import BulkActionsButtons from '·/components/bulk-actions/bulk-actions-buttons';
  import BulkAssignGroup from '·/components/bulk-actions/bulk-assign-group';
  import MoveAssignmentsTarget from '·/components/bulk-actions/move-assignments-target';
  import EventBus from '~/plugins/bus';

  export default {
    middleware: "auth",
    title: "bulk_actions_page_title",
    menuOption: "0-2",

    components: {
      ListActivities,
      ListUsers,
      FormData,
      DocumentsList,
      ValidationsList,
      WizardBulkButtons,
      BulkActionsButtons,
      WizardBulkComplete,
      BulkAssignGroup,
      MoveAssignmentsTarget,
    },

    computed: {
      projectId() {
        // console.log(this.$route.params.)
        return parseInt(this.$route.params.project_id);
      },
      bulkActionsToShow() {
        // Mostrar solo opciones de mediciones si solo hay mediciones seleccionadas
        if (
          this.assignments.length > 0 &&
          this.activities.length === 0 &&
          this.subactivities.length === 0
        ) {
          return [
            {type: 19, name: 'remove_assignments', text: 'remove_assignment_unit', title: 'eliminar mediciones'},
            {type: 20, name: 'move_assignments', text: 'move_assignments', title: 'trasladar mediciones a otra actividad'}
          ];
        }
        // Si hay actividades o subactividades, usa las acciones por defecto
        return null;
      }
      
    },

    data: () => ({
      currentActiveTab: 0,
      activities: [],
      subactivities: [],
      linkedEntities: [],
      selectedAction: null,
      sendProcessData: false,
      assignments: [],
      project: null,
    }),

    watch: {
      currentActiveTab(value) {
        if (value == 0) {
          // no aplicable
          //this.$refs.project_assignments_manual.reload();
        }
      }
    },

    mounted() {
      // Cuando el job de move/remove de mediciones termina, Notifications.vue dispara
      // este evento. Refrescamos la lista de actividades (que ahora contiene las
      // mediciones movidas/eliminadas) sin que el usuario tenga que recargar.
      EventBus.$on('bulkAssignmentsCompleted', this.onBulkAssignmentsCompleted)
    },

    beforeDestroy() {
      EventBus.$off('bulkAssignmentsCompleted', this.onBulkAssignmentsCompleted)
    },

    created() {
      this.getProjectData()
    },

    methods: {

      async getProjectData() {
        let params = {};
        const {data} = await axios.get("/api/v2/project/" + this.projectId, {params: params});
        if (data) {
          this.project = data
          // this.$refs.model_tags.initTags(data.tags);
          this.$options.subtitle = ["project_actions_page_subtitle", [this.project.name.toUpperCase()]];

        } else {
          this.$notify.error("error_loading_project_data");
        }

        this.isLoading = false;
      },

      prevTab () {
        if (this.currentActiveTab === 0 ) return

        let stepNext = (this.currentActiveTab == 2 && 
            (this.selectedAction.name === 'remove_activities' || this.selectedAction.name === 'remove_assignments')
        ) ? 2 : 1;

        const newTabIndex = this.currentActiveTab - stepNext
        const oldTabIndex = this.currentActiveTab
        // emit('change', newTabIndex, oldTabIndex)
        // await props.beforeChange()
        this.changeTab(newTabIndex)
      },

      nexTab() {
        if (this.currentActiveTab === 2) {
          this.completeWizard()
          return
        }

        if ( this.currentActiveTab == 0 && !this.validStep1() ) return
        if ( this.currentActiveTab == 1 && !this.validStep2() ) return
        // if ( this.currentActiveTab == 2 && !this.validStep2() ) return

        let stepNext = (
          this.currentActiveTab == 0 &&
          (this.selectedAction.name === 'remove_activities' || this.selectedAction.name === 'remove_assignments')
        ) ? 2 : 1;

        const newTabIndex = this.currentActiveTab + stepNext
        const oldTabIndex = this.currentActiveTab
        // emit('change', newTabIndex, oldTabIndex)
        // await props.beforeChange()
        this.changeTab(newTabIndex)
      },

      async completeWizard() {
        this.sendProcessData = true
        const actionName = this.selectedAction && this.selectedAction.name
        await this.$refs.wizard_complete.sendForm();
        this.sendProcessData = false

        // limpiamos datos seleccionados
        this.linkedEntities = []
        this.selectedAction = null
        this.activities = []
        this.subactivities = []
        this.assignments = []

        this.$refs.list_activities.clearAllSelections()

        // Para move/remove de mediciones el job corre en background: NO refrescamos
        // aquí porque la BD aún no refleja los cambios. El EventBus 'bulkAssignmentsCompleted'
        // que dispara Notifications.vue al recibir la notif Pusher se encargará de
        // refrescar la lista cuando el job termine de verdad.
        if (actionName !== 'move_assignments' && actionName !== 'remove_assignments') {
          this.$refs.list_activities.applyFilters(1)
        }
        this.changeTab(0)
      },

      // Disparado desde EventBus cuando llega la notif Pusher de un BulkAction de
      // mediciones para el usuario actual. Solo refrescamos si la notif es del
      // proyecto que estamos viendo.
      onBulkAssignmentsCompleted(payload) {
        if (!payload || payload.projectId !== this.projectId) return
        if (this.$refs.list_activities) {
          this.$refs.list_activities.clearAllSelections()
          this.$refs.list_activities.applyFilters(1)
        }
      },

      async changeTab (newTabIndex) {
        this.currentActiveTab = newTabIndex

        this.setActiveIndex()
        await this.$nextTick()
        // await props.beforeMount()
      },

      setActiveIndex()  {
        // TODO: No Hace nada ver para que puede ser usado
        // const currentTabs: any = tabs.value.entries()
        // for (const [index, tab] of currentTabs) {
        //     if (index === maxTabIndex.value + 1) {
        //         return
        //     }
        //     tab.checked = index < currentTabIndex.value
        //     tab.active = index === currentTabIndex.value
        // }
        // emit('updated:tabs', tabs, currentTabIndex)
      },

      validStep1() {
        if( this.selectedAction && (this.activities.length > 0 || this.subactivities.length > 0 || this.assignments.length > 0) )
          return true

        // Mostramos el error
        this.$toast.open({
          message: 'Debe seleccionar al menos una actividad y una acción',
          type: "is-danger",
          position: "is-top-right",
        });

        return false
      },

      validStep2() {
        if( this.linkedEntities.length > 0)
          return true

        const message = this.selectedAction && this.selectedAction.name === 'move_assignments'
          ? this.$t('move_assignments_pick_target_required')
          : this.$t('Debe seleccionar al menos un usuario');

        // Mostramos el error
        this.$toast.open({
          'message': message,
          'position': 'is-top-right',
          'type': 'is-danger'
        })

        return false
      },

      showListUsers() {
        return this.selectedAction &&
          (this.selectedAction.name === 'assign_manager' ||
            this.selectedAction.name === 'assign_participants' ||
            this.selectedAction.name === 'assign_collaborators' ||
            this.selectedAction.name === 'assign_tracking_user' ||
            this.selectedAction.name === 'remove_participants' ||
            this.selectedAction.name === 'remove_collaborators' ||
            this.selectedAction.name === 'remove_tracking_user'
          )
      },

      async onSelectAction(action) {
        this.selectedAction = action;
        this.linkedEntities = [];

        // Si la acción es eliminar mediciones, avanza al siguiente paso
        if (action.name === 'remove_assignments') {
          if (this.assignments && this.assignments.length > 0) {
          } else {
            this.$toast.open({
              message: 'Debe seleccionar al menos una medición',
              type: 'is-danger',
              position: 'is-top-right'
            });
          }
          return;
        }

        // Trasladar mediciones necesita elegir destino en el paso 2 antes del resumen.
        if (action.name === 'move_assignments') {
          if (!this.assignments || this.assignments.length === 0) {
            this.$toast.open({
              message: this.$t('move_assignments_no_selection'),
              type: 'is-danger',
              position: 'is-top-right',
            });
          }
          return;
        }

        this.$nextTick(() => {
          if (
            this.selectedAction.name === 'assign_manager' ||
            this.selectedAction.name === 'assign_participants' ||
            this.selectedAction.name === 'assign_collaborators' ||
            this.selectedAction.name === 'assign_tracking_user'
          ) {
            this.$refs.list_users.reload();
          }
        });
      },

      onSelectedItems(items) {
        this.activities = items

        if( !items.length )
          this.selectedAction = null
      },
      onSelectedAssignments(assignments) {
        this.assignments = assignments;
      }
    }
  };
</script>
